module.exports = __webpack_public_path__ + "img/pc_user_bg_qrcode_bottom.6323495c.png";